export type DeploymentHistoryEntry = {
  started_at?: string
  output?: string
  ok?: boolean
  kind?: string
}

export function findDeploymentHistoryEntry(entries: unknown, startedAt: number, expectedKind: string): DeploymentHistoryEntry | undefined {
  if (!Array.isArray(entries) || !Number.isFinite(startedAt)) return undefined
  return (entries as DeploymentHistoryEntry[]).find(entry => {
    const timestamp = Date.parse(String(entry?.started_at || ''))
    return Number.isFinite(timestamp) && timestamp >= startedAt - 5000 && (!expectedKind || entry.kind === expectedKind)
  })
}
